<template>
  <div class="content-box">
    <div class="p-tit-box">
      <div class="w92 kls">
        <div class="dis weihgs">
          <div>{{form.title}}</div>
          <div>{{form.salary}}</div>
        </div>
        <div class="dis ones">
          <div>{{form.working_place}} | {{form.department}}</div>
          <div>招聘人数：{{form.numbers}}人</div>
        </div>
      </div>
    </div>

    <div class="w92">
      <div class="panting">
        <div class="panting-tit">职位描述</div>
      </div>
      <div class="p-all">
        {{form.responsibilities}}
      </div>

      <div class="panting">
        <div class="panting-tit">职位要求</div>
      </div>
      <div class="p-all">
        {{form.requirements}}
      </div>

    </div>

  </div>
</template>

<script>
  export default {
    data() {
      return {
        form: {}
      }
    },
    mounted() {
      this.getData(this.$route.query.id)

      if (!/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.$router.push({
          path: '/join/index'
        })
      }
    },
    methods: {
      getData(id) {
        this.$request('get', this.$otapi + 'items/recruits/' + id + '?&fields=*.*&fields=images.*', {}, (res) => {
          if (res.status == 200) {
            this.form = res.data.data
          }
        })
      }
    },
    metaInfo() {
      return {
        title: '聚木网-加入我们'
      }
    }
  }
</script>
<style scoped>
  .p-tit-box {
    width: 100%;
    background: #6B78E5;
    padding: 1.25rem;
    color: #fff;
  }

  .weihgs {
    font-weight: bold;
    font-size: 1.8rem;
    margin-bottom: 0.8rem;
  }

  .ones {
    font-size: 1.3rem;
  }

  .panting {
    padding: 0.4rem 0.66rem;
    width: 9rem;
    color: #6B78E5;
    font-size: 1.5rem;
    font-weight: bold;
    background: #F1F1FD;
    margin: 1.25rem 0 1rem 0;
  }

  .panting-tit {
    padding-left: 0.66rem;
    border-left: 1px solid #6B78E5;
  }

  .content-box {
    padding-bottom: 10rem;
  }

  .p-all {
    font-size: 1.4rem;
    color: #5C5C5C;
    line-height: 24px;
  }

</style>



// WEBPACK FOOTER //
// src/components/join/article.vue